/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { IApiError } from '@global-types/index';
import { TBodyApi, TResponseApi } from 'shared/types';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const uploadMedia = (
	data: TBodyApi
): Promise<{
	id: string;
	response: TResponseApi;
}> => {
	return apiClient.post('/public/media', data);
};

export const useUploadMedia = () => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: uploadMedia,

		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading, isSuccess, data };
};
